import { ClickEvent } from "@mcleod/components";
import { McLeodClassicIntegration } from "@mcleod/core";
import { AutogenLayoutTransmissionStatusQuickInfo } from "./autogen/AutogenLayoutTransmissionStatusQuickInfo";

export class TransmissionStatusQuickInfo extends AutogenLayoutTransmissionStatusQuickInfo {
    openClassicStatus(event: ClickEvent): void {
        const id = this.sourceEdiLog.activeRow.get("id");
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.EntryEdiLog", "<ext> search id='" + id + "'");
    }
}